import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { map } from 'lodash-es';
import { useState, useCallback, useRef, useEffect } from 'react';
import ReactFullpage from '@fullpage/react-fullpage';
import { SectionIndicator } from './section-indicator';
import { PageSectionComponent } from './page-section-component';
export function HomePage(props) {
    const { sections, footer } = props;
    const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
    const navbar = document.querySelector('.site-header');
    const main = document.querySelector('.main');
    const overlay = document.querySelector('.home-page-overlay');
    useEffect(() => {
        if (sections.length === currentSectionIndex && navbar) {
            navbar.classList.add('hide');
            overlay?.classList.add('hide');
            main.setAttribute('style', 'padding-top: 0');
        }
        else if (sections.length !== currentSectionIndex && navbar) {
            navbar.classList.remove('hide');
            overlay?.classList.remove('hide');
            main.removeAttribute('style');
        }
    }, [currentSectionIndex]);
    const handleSectionChange = useCallback((origin, destination, direction) => {
        setCurrentSectionIndex(destination.index);
    }, [setCurrentSectionIndex]);
    const reactFullPageApiRef = useRef(null);
    const moveTo = useCallback((index) => {
        if (!reactFullPageApiRef.current) {
            return;
        }
        reactFullPageApiRef.current.moveTo(index + 1);
    }, [reactFullPageApiRef]);
    return (_jsxs("div", { className: "home-page", suppressHydrationWarning: true, children: [_jsx("div", { className: "home-page-overlay" }), _jsx(ReactFullpage, { onLeave: handleSectionChange, render: ({ fullpageApi }) => {
                    reactFullPageApiRef.current = fullpageApi;
                    return (_jsxs(ReactFullpage.Wrapper, { children: [map(sections, (section, index) => (_jsx(PageSectionComponent, { section: section, inFocus: index === currentSectionIndex ||
                                    /* The last section should keep focused when the user reach the footer */
                                    (index >= sections.length - 1 && currentSectionIndex >= sections.length - 1) }, section.id))), _jsx("div", { className: "section footer-container fp-auto-height", dangerouslySetInnerHTML: { __html: footer } })] }));
                } }), _jsx(SectionIndicator, { sections: map(sections, 'label'), currentSectionIndex: currentSectionIndex, changeSection: moveTo })] }));
}
